// frontend/src/pages/PaymentSuccess.js
import { Link, useLocation, useSearchParams } from "react-router-dom";

import PageContainer from "../components/layout/PageContainer";
import GlassPanel from "../components/layout/GlassPanel";

const API_URL = process.env.REACT_APP_API_URL;

export default function PaymentSuccess() {
  const location = useLocation();

  const [searchParams] = useSearchParams();

  const orderId =
    location.state?.orderId || searchParams.get("orderId") || "Unknown";

  const packageName =
    location.state?.packageName ||
    searchParams.get("packageName") ||
    "Support Package";

  const claimToken =
    location.state?.claimToken || searchParams.get("token") || "";

  const claimUrl =
    orderId !== "Unknown" && claimToken
      ? `${API_URL}/discord/start?orderId=${encodeURIComponent(
          orderId,
        )}&token=${encodeURIComponent(claimToken)}`
      : "";

  return (
    <PageContainer>
      <div
        style={{
          width: "100%",
          maxWidth: 760,
        }}
      >
        <GlassPanel>
          <div
            style={{
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontSize: 72,
                marginBottom: 20,
              }}
            >
              🎉
            </div>

            <h1
              style={{
                fontSize: 54,
                marginBottom: 20,
              }}
            >
              Payment Successful!
            </h1>

            <p
              style={{
                opacity: 0.85,
                lineHeight: 1.8,
                fontSize: 20,
              }}
            >
              Thank you for supporting Elacoria.
            </p>

            <div
              style={{
                marginTop: 32,
                background: "rgba(255,255,255,0.05)",
                borderRadius: 18,
                padding: 24,
              }}
            >
              <div>
                <strong>Package:</strong> {packageName}
              </div>

              <div
                style={{
                  marginTop: 12,
                }}
              >
                <strong>Order ID:</strong> {orderId}
              </div>
            </div>

            <div
              style={{
                marginTop: 36,
                opacity: 0.8,
                lineHeight: 1.7,
              }}
            >
              Your confirmation email includes this order link, so you can come
              back later and claim your Discord role.
            </div>

            <div
              style={{
                marginTop: 42,
                display: "flex",
                justifyContent: "center",
                gap: 16,
                flexWrap: "wrap",
              }}
            >
              {claimUrl && (
                <a
                  href={claimUrl}
                  style={{
                    padding: "14px 24px",
                    borderRadius: 14,
                    background: "#5865F2",
                    color: "#fff",
                    textDecoration: "none",
                    fontWeight: 800,
                  }}
                >
                  Claim Discord Role
                </a>
              )}

              <Link
                to="/"
                style={{
                  padding: "14px 24px",
                  borderRadius: 14,
                  background: "rgba(255,255,255,0.08)",
                  color: "#fff",
                  textDecoration: "none",
                  fontWeight: 800,
                }}
              >
                Back to Home
              </Link>
            </div>
          </div>
        </GlassPanel>
      </div>
    </PageContainer>
  );
}
